import { Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Main from "./components/Main/Main";
import LandingPage from "./components/LandingPage/LandingPage";
import AdminLogin from "./components/AdminLogin/AdminLogin";
import restaurantsItems from "./constants";
import React, { Suspense, useEffect } from "react";
import Loading from "./components/Loading/Loading";
import BydgoszczGallery from "./components/BydgoszczGallery/BydgoszczGallery";
import ReservationMenu from "./components/ReservationMenu/ReservationMenu";
import CookieConsent from "./components/CookieConsent/CookieConsent";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import Regulaminy from "./components/Regulaminy/Regulaminy";
import CigarPageBydgoszcz from "./components/CigarPageBydgoszcz/CigarPageBydgoszcz";
import GrillPrzyStoleBydgoszcz from "./components/GrillPrzyStoleBydgoszcz/GrillPrzyStoleBydgoszcz";
import GrillPrzyStoleGdansk from "./components/GrillPrzyStoleGdansk/GrillPrzyStoleGdansk";
import HistoriaCygar from "./components/HistoriaCygar/HistoriaCygar";
import RodzajeCygar from "./components/RodzajeCygar/RodzajeCygar";
import JakPalicCygaro from "./components/JakPalicCygaro/JakPalicCygaro";
import JakieCygaroNaPoczatek from "./components/JakieCygaroNaPoczatek/JakieCygaroNaPoczatek";
import JakPrzechowywacCygara from "./components/JakPrzechowywacCygara/JakPrzechowywacCygara";
import QrRedirect from "./components/QrRedirect/QrRedirect";
import { initGA, sendPageview, trackUTMs } from "./lib/ga";

function App() {
  const location = useLocation();

  useEffect(() => {
    initGA();
    trackUTMs();
    sendPageview(location.pathname + location.search);
  }, [location]);

  const LazyRestaurant = React.lazy(() => {
    return import("./components/RestaurantPage/RestaurantPage");
  });
  return (
    // <BrowserRouter>
    <>
      <Routes>
        <Route path="/go/:slug" element={<QrRedirect />} />
        <Route path="/" element={<Header />}>
          <Route path="/" element={<Footer />}>
            <Route path="/" element={<Main />}>
              <Route path="/" element={<LandingPage />} />

              <Route
                path={restaurantsItems[0].appLink}
                element={
                  <Suspense fallback={<Loading />}>
                    <LazyRestaurant myItem={restaurantsItems[0]} />
                  </Suspense>
                }
              />

              <Route
                path={restaurantsItems[1].appLink}
                element={
                  <Suspense fallback={<Loading />}>
                    <LazyRestaurant myItem={restaurantsItems[1]} />
                  </Suspense>
                }
              />
              <Route
                path={restaurantsItems[2].appLink}
                element={
                  <Suspense fallback={<Loading />}>
                    <LazyRestaurant myItem={restaurantsItems[2]} />
                  </Suspense>
                }
              />
              <Route
                path="/palarnia-cygar-bydgoszcz"
                element={
                  <Suspense fallback={<Loading />}>
                    <CigarPageBydgoszcz />
                  </Suspense>
                }
              />
              <Route path="/historia-cygar" element={<HistoriaCygar />} />
              <Route path="/rodzaje-cygar" element={<RodzajeCygar />} />
              <Route path="/jak-palic-cygaro" element={<JakPalicCygaro />} />
              <Route
                path="/jak-przechowywac-cygara"
                element={<JakPrzechowywacCygara />}
              />
              <Route
                path="/jakie-cygaro-na-poczatek"
                element={<JakieCygaroNaPoczatek />}
              />
              <Route
                path="/grill-przy-stole-bydgoszcz"
                element={
                  <Suspense fallback={<Loading />}>
                    <GrillPrzyStoleBydgoszcz />
                  </Suspense>
                }
              />

              <Route
                path="/galeria-bydgoszcz"
                element={
                  <Suspense fallback={<div>Ładowanie galerii...</div>}>
                    <BydgoszczGallery />
                  </Suspense>
                }
              />
              <Route
                path="/grill-przy-stole-gdansk"
                element={
                  <Suspense fallback={<Loading />}>
                    <GrillPrzyStoleGdansk />
                  </Suspense>
                }
              />
              <Route
                path="/rezerwacje"
                element={
                  <Suspense fallback={<Loading />}>
                    <ReservationMenu />
                  </Suspense>
                }
              />
              <Route path="/polityka-prywatnosci" element={<PrivacyPolicy />} />
              <Route path="/regulaminy" element={<Regulaminy />} />
              <Route path="/admin-panel/" element={<AdminLogin />}>
                {/* <Route path="/admin-panel/" element={<AdminLayout />}>
                <Route
                  path="/admin-panel/dashboard/"
                  element={<AdminDashboard />}
                />
                <Route
                  path="/admin-panel/newsletter/"
                  element={<AdminNewsletter />}
                />
                <Route path="/admin-panel/works/" element={<AdminWorks />} />
                <Route
                  path="/admin-panel/applications/"
                  element={<AdminApplications />}
                />
                <Route
                  path="/admin-panel/documents/"
                  element={<AdminDocuments />}
                /> */}
              </Route>
            </Route>
          </Route>
        </Route>
      </Routes>
      <CookieConsent />
    </>
    //</BrowserRouter>
  );
}

export default App;
